export interface LocalizedString {
  [langCode: string]: string;
}

export const SUPPORTED_LANGUAGES = ['ar', 'en', 'fr', 'tr', 'ur', 'ms'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const getLocalizedValue = (
  localized: LocalizedString | string | null | undefined,
  langCode: string,
  fallback: string = 'ar'
): string => {
  if (!localized) return '';
  
  // Extract base language code (e.g., 'en' from 'en-US')
  const baseLang = langCode ? langCode.split('-')[0].toLowerCase() : fallback;
  
  const extractString = (val: any): string => {
    if (typeof val === 'string') return val;
    if (val === null || val === undefined) return '';
    if (typeof val === 'object') {
      // If it's a LocalizedString, try to get the current language
      const v = val[langCode] || val[baseLang] || val[fallback] || Object.values(val).find(x => typeof x === 'string' && x.length > 0) || '';
      if (typeof v === 'string') return v;
      if (v === null || v === undefined) return '';
      // If still an object, stringify it as a last resort (to avoid React error)
      return String(v);
    }
    return String(val);
  };

  if (typeof localized === 'string') {
    // If it's a JSON string, try to parse it
    if (localized.trim().startsWith('{')) {
      try {
        const parsed = JSON.parse(localized);
        return extractString(parsed);
      } catch (e) {
        // Fallback to plain string
      }
    }
    return localized;
  }
  
  return extractString(localized);
};
